import { css, type Theme } from "@emotion/react";

export const title = css({
  padding: "0.5rem",
  paddingLeft: "0",
  fontWeight: 700,
});

export const divider = (theme: Theme) =>
  css({
    margin: "1rem 0",
    borderBottom: `1px solid ${theme.system.backgroundMutedActive}`,
  });
